export enum HeaderLayout {
  Normal,
  Minimal,
}
